export default {"src":"/_next/static/media/circle-pause-solid (1).15766a45.svg","height":512,"width":512};